export default "__VITE_ASSET__C16quybV__"